// NGRX
import {Store, select} from '@ngrx/store';
// CRUD
import {BaseDataSource, QueryResultsModel} from '../../_base/crud';
// State
import {AppState} from '../../reducers';
// Selectirs
import {selectSourceExternalReferenceQueryResult, selectSourceExternalReferencesPageLoading, selectSourceExternalReferencesShowInitWaitingMessage} from '../_selectors/source-external-reference.selectors';

export class SourceExternalReferencesDataSource extends BaseDataSource {
    trashed: number = 0;

    constructor(private store: Store<AppState>) {
        super();

        this.loading$ = this.store.pipe(
            select(selectSourceExternalReferencesPageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectSourceExternalReferencesShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectSourceExternalReferenceQueryResult)
        ).subscribe((response: QueryResultsModel) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        });

    }
}
